import './polyfill.js'
import 'typeahead.js'
import './url-handler'
import './ui'
import {logFactory} from "./log";
const log = logFactory('search:ui')
log('starting...')

